module.exports = __webpack_public_path__ + "img/1-2.714e31b1.png";